import sangtao from "../../../assets/images/sangtao.svg";
import khachhang from "../../../assets/images/khachhang.svg";
import benvung from "../../../assets/images/benvung.svg";
import chatluong from "../../../assets/images/chatluong.svg";

export default function Information2() {
  return (
    <div className="w-full container mx-auto p-3 flex flex-col gap-4 md:flex-col mt-7 lg:mt-10 lg:flex-col md:items-center md:justify-between lg:items-center lg:justify-between">
      <div className="flex flex-row gap-1 lg:flex-row lg:items-center lg:gap-2 items-center justify-center flex-wrap">
        <p className="text-xl md:text-2xl lg:text-3xl text-[#033F6A] font-semibold text-center">
          Giá trị cốt lõi của
        </p>
        <div className="border border-[#27C6FF] w-28 md:w-[7.125rem] h-10 rounded-[40px] bg-[#27C6FF] flex items-center justify-center">
          <p className="text-base md:text-lg font-semibold text-white">BlueSkyIT</p>
        </div>
      </div>
      <div className="grid grid-cols-1 w-full md:grid-cols-2 lg:grid-cols-4 gap-3">
        <div className="w-full min-h-[152px] lg:min-h-[180px] shadow-custom bg-[#27C6FF] px-4 py-4 flex flex-col gap-4 rounded-[20px]">
          <div className="flex flex-row gap-2 items-center">
            <div className="w-12 h-12 flex-shrink-0 bg-white p-2 flex items-center justify-center rounded-full">
              <img src={sangtao} alt="st" className="w-6 h-6" />
            </div>
            <div>
              <p className="text-white font-semibold text-lg md:text-xl">SÁNG TẠO</p>
            </div>
          </div>

          <div>
            <p className="text-white text-sm md:text-base font-normal">
              Không ngừng đổi mới để mang đến các giải pháp tiên tiến
            </p>
          </div>
        </div>
        <div className="w-full min-h-[152px] lg:min-h-[180px] shadow-custom bg-[#3DB72D] px-4 py-4 flex flex-col gap-4 rounded-[20px]">
          <div className="flex flex-row gap-2 items-center">
            <div className="w-12 h-12 flex-shrink-0 bg-white p-2 flex items-center justify-center rounded-full">
              <img src={chatluong} alt="st" className="w-6 h-6" />
            </div>
            <div>
              <p className="text-white font-semibold text-lg md:text-xl">CHẤT LƯỢNG</p>
            </div>
          </div>

          <div>
            <p className="text-white text-sm md:text-base font-normal">
              Cam kết về chất lượng trong từng sản phẩm và dịch vụ.
            </p>
          </div>
        </div>
        <div className="w-full min-h-[152px] lg:min-h-[180px] shadow-custom bg-[#4CA8FF] px-4 py-4 flex flex-col gap-4 rounded-[20px]">
          <div className="flex flex-row gap-2 items-center">
            <div className="w-12 h-12 flex-shrink-0 bg-white p-2 flex items-center justify-center rounded-full">
              <img src={khachhang} alt="st" className="w-6 h-6" />
            </div>
            <div>
              <p className="text-white font-semibold text-lg md:text-xl">KHÁCH HÀNG</p>
            </div>
          </div>

          <div>
            <p className="text-white text-sm md:text-base font-normal">
              Tất cả giải pháp của chúng tôi đều xuất phát từ nhu cầu của khách
              hàng
            </p>
          </div>
        </div>
        <div className="w-full min-h-[152px] lg:min-h-[180px] shadow-custom bg-[#FF3F4F] px-4 py-4 flex flex-col gap-4 rounded-[20px]">
          <div className="flex flex-row gap-2 items-center">
            <div className="w-12 h-12 flex-shrink-0 bg-white p-2 flex items-center justify-center rounded-full">
              <img src={benvung} alt="st" className="w-6 h-6" />
            </div>
            <div>
              <p className="text-white font-semibold text-lg md:text-xl">BỀN VỮNG</p>
            </div>
          </div>

          <div>
            <p className="text-white text-sm md:text-base font-normal">
              Phát triển dài hạn vì cộng đồng và môi trường.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
